"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Utility_1 = require("../../Icons/Utility");
var Typography_1 = require("../../Typography");
var Button_1 = __importDefault(require("../../Button"));
var styles_1 = __importDefault(require("./styles"));
var useStyles = (0, react_jss_1.createUseStyles)(styles_1.default);
var FIRST_PAGE = 1;
// eslint-disable-next-line no-redeclare
var Pagination = function (_a) {
    var currentPage = _a.currentPage, totalPages = _a.totalPages, onNext = _a.onNext, onBack = _a.onBack;
    var classes = useStyles();
    var disableLeft = currentPage === FIRST_PAGE;
    var disableRight = currentPage === totalPages;
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement(Button_1.default, { "aria-label": "previous page", className: classes.leftIcon, disabled: disableLeft, variant: "ghost", onClick: onBack },
            react_1.default.createElement(Utility_1.NavigatePrevious, { ariaHidden: true })),
        react_1.default.createElement(Typography_1.UtilityText, { size: "small" },
            currentPage,
            " of ",
            totalPages,
            ' ',
            totalPages === FIRST_PAGE ? 'page' : 'pages'),
        react_1.default.createElement(Button_1.default, { "aria-label": "next page", className: classes.rightIcon, disabled: disableRight, variant: "ghost", onClick: onNext },
            react_1.default.createElement(Utility_1.NavigateNext, { ariaHidden: true }))));
};
exports.default = Pagination;
